<template>
    <div class="frame-group-container">
        <div class="frame-group-inner">
            <div class="frame-container frame-container-default">
                <div class="frame-inner">
                    <div class="row row-columns">
                        <Transition>
                            <div v-if="!sent" class="col-100">
                                <form class="registration revocation" ref="formRef">
                                    <div class="form-container">
                                        <TextInput 
                                            :value="formData.eventTitle" 
                                            :id="'eventTitle'" 
                                            :label="'Veranstaltungstitel'" 
                                            :placeholder="'Veranstaltungstitel'" 
                                            :required="true" 
                                            @update:value="(event) => formData.eventTitle = event"
                                            :hasError="eventTitleError"
                                            :errorText="'Bitte geben Sie den Veranstaltungstitel an.'"
                                        />
                                        <TextInput 
                                            :value="formData.eventNumber" 
                                            :id="'eventNumber'" 
                                            :label="'Veranstaltungs-Nr.'" 
                                            :placeholder="'Veranstaltungs-Nr. (falls vorhanden)'" 
                                            :required="false" 
                                            @update:value="(event) => formData.eventNumber = event"
                                        />
                                        <div class="form-group form-group__date" :class="{'has-error' : eventDateError}">
                                            <label class="form-label" for="eventDate">Datum der Veranstaltung *</label>
                                            <div class="input">
                                                <input 
                                                    v-model="formData.eventDate" 
                                                    type="date" 
                                                    class="form-control" 
                                                    :class="{'error' : eventDateError}" 
                                                    id="eventDate" 
                                                    name="eventDate" 
                                                    required
                                                >
                                                <div v-if="eventDateError" class="error form-text" role="alert">
                                                    Bitte geben Sie das Datum der Veranstaltung an.
                                                </div>
                                            </div>
                                        </div>
                                        <div></div>
                                        <TextInput 
                                            :value="formData.lastName" 
                                            :id="'lastName'" 
                                            :label="'Nachname'" 
                                            :placeholder="'Nachname'" 
                                            :required="true" 
                                            @update:value="(event) => formData.lastName = event"
                                            :hasError="lastNameError"
                                            :errorText="'Bitte geben Sie Ihren Nachnamen an.'"
                                        />
                                        <TextInput 
                                            :value="formData.firstName" 
                                            :id="'firstName'" 
                                            :label="'Vorname'" 
                                            :placeholder="'Vorname'" 
                                            :required="true" 
                                            @update:value="(event) => formData.firstName = event"
                                            :hasError="firstNameError"
                                            :errorText="'Bitte geben Sie Ihren Vornamen an.'"
                                        />
                                        <TextInput 
                                            :value="formData.street" 
                                            :id="'street'" 
                                            :label="'Straße, Nr.'" 
                                            :placeholder="'Straße, Nr.'" 
                                            :required="true" 
                                            @update:value="(event) => formData.street = event"
                                            :hasError="streetError"
                                            :errorText="'Bitte geben Sie Ihre Adresse an.'"
                                        />
                                        <TextInput 
                                            :value="formData.postcode" 
                                            :id="'postcode'" 
                                            :label="'PLZ'" 
                                            :placeholder="'PLZ'" 
                                            :required="true" 
                                            @update:value="(event) => formData.postcode = event"
                                            :hasError="postcodeError"
                                            :errorText="'Bitte geben Sie Ihre PLZ an.'"
                                        />
                                        <TextInput 
                                            :value="formData.city" 
                                            :id="'city'" 
                                            :label="'Ort'" 
                                            :placeholder="'Ort'" 
                                            :required="true" 
                                            @update:value="(event) => formData.city = event"
                                            :hasError="cityError"
                                            :errorText="'Bitte geben Sie Ihren Wohnort an.'"
                                        />
                                        <div></div>
                                        <TextInput 
                                            :value="formData.email" 
                                            :id="'email'" 
                                            :label="'E-Mail'" 
                                            :placeholder="'E-Mail'" 
                                            :required="true" 
                                            @update:value="(event) => formData.email = event"
                                            :hasError="emailError"
                                            :errorText="'Bitte geben Sie Ihre E-Mail-Adresse an.'"
                                        />
                                        <TextInput 
                                            :value="formData.phone" 
                                            :id="'phone'" 
                                            :label="'Telefon'" 
                                            :placeholder="'Telefon'" 
                                            :required="false" 
                                            @update:value="(event) => formData.phone = event"
                                        />
                                        <div class="form-group form-group__comment">
                                            <label class="form-label" for="comment">Kommentar</label>
                                            <div class="input">
                                                <textarea 
                                                    v-model="formData.comment" 
                                                    class="form-control" 
                                                    id="comment" 
                                                    name="comment" 
                                                    placeholder="Kommentar (freiwillig)"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="captcha-container">
                                        <div class="form-group form-group__captcha" :class="{'has-error' : captchaError}">
                                            <div class="input" id="captcha">
                                                <Captcha
                                                    v-model="altchaPayload"
                                                    @update:payload="(event) => formData.captcha = event"
                                                />
                                                <div v-if="captchaError" class="error form-text" role="alert">
                                                    Führen Sie die Sicherheitsprüfung durch.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>* Pflichtangaben</div>
                                    <div v-if="serverError" :class="{'has-error' : serverError}">
                                        <div class="error form-text">
                                            Serverfehler: Bitte versuchen Sie es erneut oder laden Sie die Seite neu.
                                        </div>
                                    </div>
                                    <div class="button-container">
                                        <button @click.prevent="validateFormData" class="btn btn-primary">Jetzt widerrufen</button>
                                    </div>
                                </form>        
                            </div>
                            <div v-else class="col-100">
                                <SubmitFeedback @close-modal="resetForm" :success="submitResult.success">
                                    <span class="feedback-text">{{ submitResult.message1 }}</span>
                                    <span class="feedback-text">{{ submitResult.message2 }}</span>
                                </SubmitFeedback>
                            </div>
                        </Transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Captcha from '../components/Captcha.vue';
import TextInput from '../components/Inputs/TextInput.vue';
import SubmitFeedback from './Partial Views/SubmitFeedback.vue';

import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
    regionId: String
})

const altchaPayload = ref("");

const sent = ref(false);
const submitResult = ref({success: false, message1: "", message2: ""});

const serverError = ref(false);

const getRegionId = () => {
    // Prio 1: data-attribute
    if (props.regionId) {
        return props.regionId;
    }
    // Prio 2: Query-Param
    const urlParams = new URLSearchParams(window.location.search);
    const queryId = urlParams.get('regionId') || urlParams.get('region-id');
    if (queryId) {
        return queryId;
    }
    return "";
};

const formData = reactive({
    eventTitle: ref(""),
    eventNumber: ref(""),
    eventDate: ref(""),
    lastName: ref(""),
    firstName: ref(""),
    street: ref(""),
    postcode: ref(""),
    city: ref(""),
    email: ref(""),
    phone: ref(""),
    comment: ref(""),
    captcha: ref(""),
    regionId: getRegionId()
});

const resetForm = () => {
    formData.eventTitle = "";
    formData.eventNumber = "";
    formData.eventDate = "";
    formData.lastName = "";
    formData.firstName = "";
    formData.street = "";
    formData.postcode = "";
    formData.city = "";
    formData.email = "";
    formData.phone = "";
    formData.comment = "";
    formData.captcha = "";

    submitted.value = false;
    serverError.value = false;

    setTimeout(() => {
        submitResult.value.success = false;
        submitResult.value.message1 = "";
        submitResult.value.message2 = "";
        sent.value = false;
    }, 200);
}

/*
*   Validation
*/

const submitted = ref(false);

const eventTitleError = computed(() => {
    return submitted.value && !(formData.eventTitle.length > 2);
})

const eventDateError = computed(() => {
    return submitted.value && !formData.eventDate;
})

const lastNameError = computed(() => {
    return submitted.value && !(formData.lastName.length > 1);
})

const firstNameError = computed(() => {
    return submitted.value && !(formData.firstName.length > 1);
})

const streetError = computed(() => {
    const simpleAddressRegex = /^[a-zA-ZäöüÄÖÜß\s.,\-]{3,}.*\d+.*$/;
    return submitted.value && !simpleAddressRegex.test(formData.street);
})

const postcodeError = computed(() => {
    const postcodeRegex = /^\d{5}$/;
    return submitted.value && !postcodeRegex.test(formData.postcode);
})

const cityError = computed(() => {
    return submitted.value && !(formData.city.length > 2);
})

const emailError = computed(() => {
    const mailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return submitted.value && !mailRegex.test(formData.email);
})

const captchaError = computed(() => {
    return submitted.value && (!formData.captcha || formData.captcha.length <= 0);
})

function validateFormData() {
    submitted.value = true;
    let hasError = false;

    if (eventTitleError.value || eventDateError.value || lastNameError.value || 
        firstNameError.value || streetError.value || postcodeError.value || 
        cityError.value || emailError.value || captchaError.value) {
        hasError = true;
    }

    if (!hasError) {
        sendFormData();
    } else {
        setTimeout(() => {
            const modal = document.querySelector('.modal');
            const firstErrorElement = document.querySelector('.has-error');
            if(firstErrorElement){
                const topmetaHeight = document.querySelector('.topmeta')?.offsetHeight || 0;
                const headerHeight = document.querySelector('#page-headerNavbar')?.offsetHeight || 0;
                const elementPosition = firstErrorElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - topmetaHeight - headerHeight;

                if (modal) {
                    modal.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }
            }
        }, 50)
    }
}

async function sendFormData() {
    const url = "/api/events/revocation.json";
    const payload = JSON.stringify(Object.fromEntries(
        Object.entries(formData).map(([k, v]) => [k, v && v.value !== undefined ? v.value : v])
    ));
    const headers = { 'Content-Type': 'application/json' };

    try {
        const response = await fetch(url, {
            method: "POST",
            headers,
            body: payload
        });
        const result = await response.json();
        if(result.success){
            sent.value = true;
            submitResult.value.success = true;
            submitResult.value.message1 = result.message1 ? result.message1 : "Ihr Widerruf wurde versendet.";
            submitResult.value.message2 = result.message2 ? result.message2 : "In Kürze erhalten Sie eine Bestätigung per E-Mail.";
        } else if(result.errorMessage) {
            sent.value = true;
            submitResult.value.success = false;
            submitResult.value.message1 = result.errorMessage;
        } else if(result.formErrors) {
            serverError.value = true;
        } else {
            throw new Error(`Request failed. Status: ${response.statusText}`)
        }
    } catch (error) {
        console.error(error);
    }
}

/*
*   Bootstrap modal beobachten und Form resetten, wenn geschlossen wird + abgesendet wurde
*/

let modalObserver = null;
const formRef = ref(null);

onMounted(() => {
    const formElement = formRef.value;
    if (!formElement) return;
    
    const modalElement = formElement.closest('.modal');
    if (!modalElement) return;

    modalObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if(mutation.attributeName === 'class') {
                const modalClosed = !modalElement.classList.contains('show');

                if(modalClosed) {
                    if(sent.value){
                        resetForm();
                    }
                }
            }
        })
    });

    modalObserver.observe(modalElement, {
        attributes: true,
        attributeFilter: ['class']
    })
})

onBeforeUnmount(() => {
    if(modalObserver){
        modalObserver.disconnect();
    }
})
</script>
